// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-m__button__A5RBZ"};